var map = {
	"./blackGold/main/cardgameback.png": 93874,
	"./brownGold/main/cardgameback.png": 91091,
	"./darkBlue/main/cardgameback.png": 89122,
	"./greenYellow/main/cardgameback.png": 73369,
	"./redGold/main/cardgameback.png": 66861,
	"./skyBlue/main/cardgameback.png": 5520,
	"./whiteGold/main/cardgameback.png": 89669,
	"./yellowWhite/main/cardgameback.png": 68834
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 68863;